import { ReduxService } from 'dashboard-services/services';

import { descModalDataScienceActions } from 'actions/modules/datascience';

export const descModalInitial = {
  creator: false,
  id: undefined,
  open: false
}

export default (state = descModalInitial, action) => {
  switch (action.type) {
    case descModalDataScienceActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}